"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterValveState = exports.ValveStatus = exports.ValveState = void 0;
var ValveState;
(function (ValveState) {
    ValveState["OPEN"] = "Open";
    ValveState["CLOSED"] = "Closed";
})(ValveState || (exports.ValveState = ValveState = {}));
var ValveStatus;
(function (ValveStatus) {
    ValveStatus["ONLINE"] = "Online - not irrigating";
    ValveStatus["OFFLINE"] = "Offline";
    ValveStatus["ERROR"] = "Error";
    ValveStatus["IRRIGATING"] = "Irrigating";
    ValveStatus["UNSEEN"] = "Never Seen";
    ValveStatus["DISABLED"] = "Disabled";
    ValveStatus["AREAPAUSED"] = "Paused";
    ValveStatus["AWAITINGPROGRAMME"] = "Programme Pending";
})(ValveStatus || (exports.ValveStatus = ValveStatus = {}));
var MasterValveState;
(function (MasterValveState) {
    MasterValveState["ONLINE"] = "Online - not irrigating";
    MasterValveState["OFFLINE"] = "Offline";
    MasterValveState["ERROR"] = "Error";
    // IRRIGATING = ValveStatus.IRRIGATING,
    MasterValveState["UNSEEN"] = "Never Seen";
    MasterValveState["DISABLED"] = "Disabled";
    MasterValveState["AREAPAUSED"] = "Paused";
    MasterValveState["AWAITINGPROGRAMME"] = "Programme Pending";
    MasterValveState["OPEN"] = "Open";
    MasterValveState["CLOSED"] = "Closed";
})(MasterValveState || (exports.MasterValveState = MasterValveState = {}));
